module.exports = __webpack_public_path__ + "static/img/Diya.2d4b32f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Stamp Assests/Diya.svg
// module id = R5No
// module chunks = 1